import Dispatcher from '../dispatcher';
import { SelectFSLightBoxActions } from '../constants/select_fs_light_box/select_fs_light_box_actions';

function showAction(payload) {
    Dispatcher.handleSelectFSLightboxAction({
        type: SelectFSLightBoxActions.SHOW,
        payload,
    });
}

function showErrorAction(error) {
    Dispatcher.handleSelectFSLightboxAction({
        type: SelectFSLightBoxActions.ERROR,
        payload: error,
    });
}

function hideAction() {
    Dispatcher.handleSelectFSLightboxAction({
        type: SelectFSLightBoxActions.HIDE
    });
}

export {
    showAction,
    showErrorAction,
    hideAction,
};
